'use client'
import React, { createContext, useContext, useState, ReactNode } from "react";
import { X } from "lucide-react";

type ConfirmOptions = {
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
    textDirection?: string;
};

type ConfirmContextType = {
    confirm: (options: ConfirmOptions) => Promise<boolean>;
};

const ConfirmContext = createContext<ConfirmContextType | null>(null);

export function ConfirmationBox({ children }: { children: ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const [options, setOptions] = useState<ConfirmOptions>({});
    const [resolver, setResolver] = useState<(value: boolean) => void>(() => { });

    const confirm = (options: ConfirmOptions) => {
        setOptions(options);
        setIsOpen(true);
        return new Promise<boolean>((resolve) => {
            setResolver(() => resolve);
        });
    };

    const handleConfirm = () => {
        setIsOpen(false);
        resolver(true);
    };
    const handleCancel = () => {
        setIsOpen(false);
        resolver(false);
    };

    return (
        <ConfirmContext.Provider value={{ confirm }}>
            {children}

            {/* A simple modal (customize however you want) */}
            {isOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-80 backdrop-blur-md ">
                    <div className="text-neutral-700  bg-white/60 shadow-xl shadow-neutral-500/30 border border-neutral-100 backdrop-blur-xl pointer-events-auto pb-6 rounded-[5px] w-[400px]">
                        <div className="flex items-start mx-1 mt-1">
                            <button className="ml-auto pointer-events-auto cursor-pointer text-neutral-500 hover:text-neutral-800" onClick={handleCancel}>
                                <X size={20} />
                            </button>
                        </div>
                        <div className="px-5  ">
                            {/* <h2 className="sub-header-font mb-1">{options.title || "Are you sure?"}</h2> */}
                            <p className={`sub-header-font mb-8 p-2 flex justify-end ${options.textDirection}`}>{options.message || "Do you want to proceed?"}</p>

                            <div className="flex justify-center gap-14 details-font mx-7 border-t-2 pt-4 border-[#f4cea1] ">

                                <button
                                    className="text-neutral-500 text-neutral-500 hover:text-neutral-800 pointer-events-auto cursor-pointer"
                                    onClick={handleCancel}
                                >

                                    {options.confirmText || "Confirm"}
                                </button>

                                <div className="text-[#ff8904]/65">|</div>

                                <button
                                    className=" pointer-events-auto cursor-pointer text-neutral-500 hover:text-neutral-800"

                                    onClick={handleConfirm}
                                >

                                    {options.cancelText || "Cancel"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </ConfirmContext.Provider>
    );
}
export const useConfirm = () => {
    const context = useContext(ConfirmContext);
    if (!context) throw new Error("useConfirm must be used within ConfirmProvider");
    return context.confirm;
};